import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ViewerSettings } from '@/types/fileViewer';

interface ImageViewerProps {
  fileUrl: string;
  fileName: string;
  settings: ViewerSettings;
  containerRef?: React.RefObject<HTMLDivElement | null>;
  onError?: () => void;
}

const ImageViewer: React.FC<ImageViewerProps> = ({
  fileUrl,
  fileName,
  settings,
  containerRef,
  onError,
}) => {
  const { zoom, rotation } = settings;
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
    onError?.();
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
      }}
    >
      <Box
        sx={{
          minHeight: 'calc(100% - 56px)', // header 높이만큼 뺌
          padding: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            transform: `rotate(${rotation}deg) scale(${zoom / 100})`,
            transformOrigin: 'center',
            transition: 'transform 0.2s ease-out',
          }}
        >
          {hasError ? (
            <Box
              sx={{
                color: '#FFFFFF',
                textAlign: 'center',
                padding: '40px',
              }}
            >
              이미지를 불러올 수 없습니다.
            </Box>
          ) : (
            <img
              src={fileUrl}
              alt={fileName}
              onError={handleError}
              style={{
                maxWidth: '100%',
                maxHeight: 'calc(100vh - 80px - 80px - 100px)', // viewport - padding - header - toolbar
                width: 'auto',
                height: 'auto',
                display: 'block',
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ImageViewer;
